import ConvertHTMLToPDF from "../utils/ConvertHTMLToPDF.js";

function calculateIdealPdfHeight() {
	// Get the document scroll height
	const scrollHeight = document.body.scrollHeight;

  // Constants to define the proportion between scrollHeight and PDF height
  const scaleFactor = 0.258;

  // Calculate the ideal PDF height using the scaleFactor
  const idealPdfHeight = scrollHeight * scaleFactor;

  // Round the result to the nearest millimeter
  const roundedIdealPdfHeight = Math.round(idealPdfHeight);

  return roundedIdealPdfHeight;
}

function downloadMediaKitPDF() {
  ConvertHTMLToPDF({
    selector: '[data-id="00b1159"]',
    filename: "my-mediakit.pdf",
    scale: 0.8,
    margin: [5, 5, 5, 5],
    autoPaging: "text",
		docHeight: calculateIdealPdfHeight(),
    x: 0,
    y: 0,
    width: 200,
    windowWidth: 975
  });
}

export default downloadMediaKitPDF;
